import { AxiosResponse } from 'axios'
import { MainAction } from './models'
import {
  FETCH_BOOKMARKS_LIST,
  GET_DEFAULT_BOOKMARK,
  REMOVE_BOOKMARK,
  SET_BOOKMARK,
} from './types'
import { BookmarkStateProps, IBookmark } from '../types'
import { toast } from 'react-toastify'

export const fetchBookmark: MainAction<[number, number, any]> =
  (perPage, page, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      dispatch({
        type: FETCH_BOOKMARKS_LIST,
        data: getState().bookmarkReducer.data,
        loading: true,
        pagination: getState().bookmarkReducer.pagination,
      })

      const params = {
        'with[]': 'photos',
        perpage: perPage,
        page,
      }

      const res: AxiosResponse<{
        data: {
          records: BookmarkStateProps[]
          pagination: any
        }
      }> = await api.get('profile/bookmarks', params)

      if (res?.status === 200 && res?.data?.data?.records) {
        const bookmarkIds = res?.data?.data?.records.map(item => item.id)
        dispatch({
          type: FETCH_BOOKMARKS_LIST,
          data: [...getState().bookmarkReducer.data, ...bookmarkIds],
          loading: false,
          pagination: res?.data?.data?.pagination,
        })
        callback({
          list: res?.data?.data?.records ?? [],
          pagination: res?.data?.data?.pagination,
        })
      } else {
        dispatch({
          type: FETCH_BOOKMARKS_LIST,
          data: getState().bookmarkReducer.data,
          loading: false,
          pagination: res?.data?.data?.pagination,
        })
        callback({
          list: [],
          pagination: res?.data?.data?.pagination,
        })
      }
      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_BOOKMARKS_LIST,
        data: [],
        loading: false,
        pagination: null,
      })
      if (err) {
        toast.info('خطا در دریافت اطلاعات از سرور!')
      }

      // Handle Err
    }
  }

export const setBookmark: MainAction<[IBookmark]> =
  ({ id }: IBookmark) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      const res: AxiosResponse<any> = await api.post('house/bookmark', {
        house_id: id,
      })

      dispatch({
        type: SET_BOOKMARK,
        data: [...(getState().bookmarkReducer?.data || []), id],
        loading: false,
      })

      sessionStorage.setItem('bookmark_list', `[]`)

      // Handle Res
    } catch (err) {
      dispatch({
        type: SET_BOOKMARK,
        data: [],
        loading: false,
      })
      // Handle Err
    }
  }

export const getDefaultBookmark = (data: IBookmark[]) => ({
  type: GET_DEFAULT_BOOKMARK,
  data: data,
  loading: false,
})

export const removeBookmark: MainAction<[IBookmark]> =
  ({ id }: IBookmark) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      const res: AxiosResponse<any> = await api.post('house/bookmark', {
        house_id: id,
      })

      const localData = getState().bookmarkReducer.data.filter(
        item => item !== id,
      )

      dispatch({
        type: REMOVE_BOOKMARK,
        data: localData,
        loading: false,
        pagination: getState().bookmarkReducer.pagination,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: REMOVE_BOOKMARK,
        data: [],
        loading: false,
        pagination: null,
      })
      // Handle Err
    }
  }
